const BookOneMoverWarnModal = ({
  isOpen,
  open,
  onClose,
  onConfirm,

  handleUpdateBookingObject,
  setLabourNeeded,
  handleEstimatePrice,

}) => {
  const visible = typeof isOpen === 'boolean' ? isOpen : !!open
  if (!visible) return null

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#7876A1]/50 font-instrument">
      {/* Main modal container */}
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Book one mover warning"
        className="relative rounded-2xl overflow-hidden font-instrument flex flex-col items-center justify-center px-[15px] pb-[15px]"
        style={{
          width: 328,
          background: '#F6F6F6',
          borderRadius: '16px',
          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
        }}
      >
        {/* Close button top-left */}
        <div className="flex justify-start items-start w-full pt-[16px] cursor-pointer">
          <img
            onClick={onClose}
            src="/Vision Agent Icons/X Icon/XLightpurple.svg" alt="close" />
        </div>


        {/* Title and icon container */}
        <div className="flex items-center gap-2 mt-[20px]">
          <h2 className="text-[24px] font-semibold text-[#34318C] leading-tight">
            Book 1 mover?
          </h2>

          {/* Attention icon container */}
          <div className="relative w-[37px] h-[37px] flex items-center justify-center">
            <img
              src="/images/NewUiIcons/Polygon4.svg"
              alt="decorative polygon"
              className="absolute inset-0 w-full h-full"
            />
            <img
              src="/images/NewUiIcons/AttentionIcon.png"
              alt="attention"
              className="relative w-[17px] h-[17px] z-10 mt-1"
            />
          </div>
        </div>

        {/* Description text */}
        <p className="mt-[18px] text-[14px] text-[#34318C] font-normal leading-[120%] text-center max-w-[278px] mx-auto">
          You'll need to help load and unload items.<br />
          We recommend at least <span className="font-semibold">2 movers</span> for safety and efficiency.
        </p>


        {/* Buttons container */}
        <div className="flex w-full justify-center mt-[16px] gap-2">
          <button
            onClick={() => {
       
              onClose && onClose()
              setLabourNeeded(2)
              handleUpdateBookingObject("tripStatus", "schedule", "continue.with.two.mover")
              handleUpdateBookingObject("labourNeeded", 2, "continue.with.two.mover")
              handleEstimatePrice();
            }}
            className="flex-1 w-[145px] bg-[#C8C6DF] text-[#34318C] h-[48px] rounded-[15px] font-semibold text-[14px] hover:bg-[#d0cce8] focus:outline-none transition-colors"
            aria-label="Keep 2 movers"
          >
            Keep 2 movers
          </button>

          <button
            onClick={() => {
              onConfirm && onConfirm()
              onClose && onClose()
              handleUpdateBookingObject("tripStatus", "schedule", "continue.with.one.mover")
            }}
            className="flex-1 w-[145px] bg-[#34318C] text-white h-[48px] rounded-[15px] leading-[14px] font-semibold text-[14px] hover:bg-[#2a276b] focus:outline-none transition-colors"
            aria-label="Book 1 mover anyway"
          >
            Book 1 mover <br /> anyway
          </button>
        </div>
      </div>
    </div>
  )
}

export default BookOneMoverWarnModal